import _ from 'lodash';
import {
  AssetCatalogResponse,
  ParAssetCatalogOptionResponse,
} from '../../../services/assetconfig';
import moment from 'moment';
import { AssetResponse } from 'services/assets';

export function assetCatalogToAsset(
  data: AssetCatalogResponse,
  listrv: any,
  nbasset: number,
  cteid: number,
  origine: string,
  listuse: any,
  flaguseassetgrossamount?: boolean,
  _assetCatalog?: any
): AssetResponse {
  if (nbasset === null) {
    nbasset = 1;
  }

  let assetCatalogOptionsToPropose: ParAssetCatalogOptionResponse[] =
    data.assetCatalogOptions?.filter((opt) => opt.flagtopropose);

  let listOfDurationMin: number[] = listrv.map((rv: any) => rv.monthsmin);
  let listOfDurationMax: number[] = listrv.map((rv: any) => rv.monthsmax);

  let _listDistinctDuration: number[] = _.uniq([
    ...listOfDurationMin,
    ...listOfDurationMax,
  ]);

  let marksDuration: { [key: number]: string } = {};
  _listDistinctDuration.forEach((e: number, index: number) => {
    let marks=localStorage.getItem('lancode') === 'EN'? 'Months' : 'Mois';
    let key: number = e;
    let value: string = String(e) + marks;
    marksDuration[key] = value; // Add key-value pairs to the object
  });

  let listMarksMillageByDuration = _listDistinctDuration.map(
    (duration: number) => {
      let listMillageByDuration = listrv.filter(
        (rv: any) => rv.monthsmin === duration || rv.monthsmax === duration
      );

      let listOfMillageMin: number[] = listMillageByDuration.map(
        (rv: any) => rv.mileagemin
      );
      let listOfMillageMax: number[] = listMillageByDuration.map(
        (rv: any) => rv.mileagemax
      );

      let _listDistinct: number[] = _.uniq([
        ...listOfMillageMin,
        ...listOfMillageMax,
      ]);

      let marks: { [key: number]: string } = {};

      _listDistinct.forEach((e: number, index: number) => {
        let key: number = e;
        let value: string = String(e) + 'Km';
        marks[key] = value; // Add key-value pairs to the object
      });

      return {
        duration,
        marks,
        minMillage: Math.min(..._listDistinct),
        maxMillage: Math.max(..._listDistinct),
      };
    }
  );

  let rvDurationDefault = Math.min(..._listDistinctDuration);

  let listMillageByDuration = listrv.filter(
    (rv: any) =>
      rv.monthsmin === rvDurationDefault || rv.monthsmax === rvDurationDefault
  );

  let listOfMillageMin: number[] = listMillageByDuration.map(
    (rv: any) => rv.mileagemin
  );
  let listOfMillageMax: number[] = listMillageByDuration.map(
    (rv: any) => rv.mileagemax
  );

  let _listDistinctMillage: number[] = _.uniq([
    ...listOfMillageMin,
    ...listOfMillageMax,
  ]);

  let rvamountByDurationAndMillage = listrv.find(
    (i: any) => i.mileagemin === Math.min(..._listDistinctMillage)
  )?.rvamount;

  return {
    assetCatalogAvailableOptions: data.assetCatalogOptions,
    assetmodellabel: data.assetmodellabel,
    assettaggrouping: '',
    cteid: cteid,
    assetpictureurl: data.assetpictureurl,
    listrv: listrv,
    irvSchedule: [],
    assetusereqList: listuse,
    entityAddAttributList: data.entityAddAttributList ?? [],
    catalogid: data.catalogid,
    assetqty: nbasset,
    assetsegment: data.assetsegment,
    assetsegmentlabel: data.assetsegmentlabel,
    power: data.power,
    weight: data.weight,
    assetfamily: data.assetfamily,
    assetclass: data.assetclass,
    assetfamilylabel: data.assetfamilylabel,
    assetunitnetamount:
      origine === 'free' ? data.assetnetamount / nbasset : data.assetnetamount,
    assetComponents: data.assetCatalogComponents,
    assetcategory: data.assetcategory,
    assetcategorylabel: data.assetcategorylabel,
    assetconstructor: data.assetconstructor,
    assetexpdeliverydate: moment()
      .add(Number(data.deliverydelay ?? 0), 'd')
      .toString(),
    assetdeliverydate: '',
    assetdeliveryreference: '',
    assetdescription: data.assetdescription,
    assetgrossamount:
      origine === 'free'
        ? data.assetgrossamount
        : data.assetgrossamount * nbasset,
    // assetid: data.catalogid,
    assetid: Math.floor(_.random(10000000)),
    assetlabel: data.assetlabel,
    assetmodel: data.assetmodel,
    assetmulticomponents: data.assetmulticomponents ?? false,
    assetnetamount:
      origine === 'free' ? data.assetnetamount : data.assetnetamount * nbasset,
    assetorderdate: moment().format('YYYY-MM-DD'),
    assetorderreference: '',
    assetphase: 'INIT',
    assetreference: '',
    assetrisklevel: '',
    assetstatus: 'INIT',
    assetstatusdate: moment().format('YYYY-MM-DD'),
    assettaxamount:
      origine === 'free' ? data.assettaxamount : data.assettaxamount * nbasset,
    assettype: data.assettype,
    assettypelabel: data.assettypelabel,
    chassisno: data.chassisno ?? '',
    created_at: moment().format('YYYY-MM-DD'),
    created_by: 0,
    currcode: data.currcode ?? 'EUR',
    deliveryadrcity: '',
    deliveryadrcountry: '',
    deliveryadrregion: '',
    deliveryadrstreet1: '',
    deliveryadrstreet2: '',
    deliveryadrzipcode: '',
    engineno: '',
    fiscaldepreciationmethod: '',
    flagused: false,
    last_action: '',
    plateno: '',
    registrationno: '',
    serialno: '',
    statuslabel: data.statuslabel ?? '',
    assetstatuslabel: data.assetstatuslabel ?? '',
    suppliername: data.suppliername,
    supplierreference: data.supplierreference,
    tpidsupplier: data.tpidsupplier,
    manufacturername: data.manufacturername,
    manufacturerreference: data.manufacturerreference,
    tpidmanufacturer: data.tpidmanufacturer,
    taxcode: data.taxcode,
    taxrate: data.taxrate,
    updated_at: moment().format('YYYY-MM-DD'),
    updated_by: 0,
    flagholdback: false,
    holdbackpercentage: 0,
    holdbackamount: 0,
    holdbackbeleasenbdays: 0,
    holdbackbeleasedate: '',
    kwhdegradation: data.kwhdegradation,
    kwhpower: data.kwhpower,
    kwhproduction: data.kwhproduction,
    assetfinamount: flaguseassetgrossamount
      ? data.assetgrossamount
      : origine === 'free'
      ? data.assetnetamount
      : data.assetnetamount * nbasset,
    brokername: data.brokername,
    brokerreference: data.brokerreference,
    degfeesformula: data.degfeesformula,
    networkcode: data.networkcode,
    spfeesformula: data.spfeesformula,
    tpidbroker: data.tpidbroker,
    tpofformula: data.tpofformula,
    assetServiceList: data.assetCatalogServices,
    partamount: data.partamount,
    partmethod: data.partmethod,
    partmethodlabel: data.partmethodlabel,
    partnbdays: data.partnbdays,
    partrate: data.partrate,
    assetCatalogOptionsToPropose: assetCatalogOptionsToPropose,
    assetUpgradeList: data.assetUpgradeList,
    wheeldrive: data?.wheeldrive,
    balersize: data?.balersize,
    separatortype: data?.separatortype,
    transmission: data?.transmission,
    wheeltrack: data?.wheeltrack,
    lift: data?.lift,
    capacity: data?.capacity,
    tankcapacity: data?.tankcapacity,
    nbcampaign: data?.nbcampaign,
    threshinghours: data?.threshinghours,
    rotorhours: data?.rotorhours,
    totalbalers: data?.totalbalers,
    registrationcity: data?.registrationcity,
    registrationname: data?.registrationname,
    registrationdate: data?.registrationdate,
    firstregistrationdate: data?.firstregistrationdate,
    fiscalpower: data?.fiscalpower,
    country: data?.country,
    durationList: _listDistinctDuration,
    marksDuration: marksDuration,
    listMarksMillageByDuration: listMarksMillageByDuration,
    rvDuration: Math.min(..._listDistinctDuration),
    rvamountByDuration: rvamountByDurationAndMillage,
    assetCatalog: _assetCatalog,
  };
}
